module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshData()
      }
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n          " + _vm._s(tabitem) + "\n        ")])
  }), 1), _vm._v(" "), _c('v-tabs-items', {
    on: {
      "change": function($event) {
        return _vm.refreshData()
      }
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [(tabitem === 'General') ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(_vm.lCompAdr) ? _c('v-card', {
      staticClass: "pa-0",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary--text subheader pb-0"
    }, [_vm._v("Complaints can be addressed to")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0"
    }, [(_vm.isHDPresent) ? _c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": "Helpdesk Executive"
      },
      on: {
        "change": _vm.saveCompSet
      },
      model: {
        value: (_vm.lCompAdr.is_hd_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompAdr, "is_hd_enabled", $$v)
        },
        expression: "lCompAdr.is_hd_enabled"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isFMPresent) ? _c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": "FM"
      },
      on: {
        "change": _vm.saveCompSet
      },
      model: {
        value: (_vm.lCompAdr.is_fm_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompAdr, "is_fm_enabled", $$v)
        },
        expression: "lCompAdr.is_fm_enabled"
      }
    }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": "Mgmt Committee"
      },
      on: {
        "change": _vm.saveCompSet
      },
      model: {
        value: (_vm.lCompAdr.is_mc_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompAdr, "is_mc_enabled", $$v)
        },
        expression: "lCompAdr.is_mc_enabled"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary--text subheader pb-0"
    }, [_vm._v("Services / Complaint categories")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md6": ""
      }
    }, [_c('v-btn', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "color": "accent mb-0",
        "flat": ""
      },
      on: {
        "click": _vm.prepareCreate
      }
    }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-3",
      attrs: {
        "headers": _vm.catSet,
        "items": _vm.catList,
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareEdit(props.item)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(props.item.comp_cat))])])]
        }
      }], null, true)
    })], 1)], 1)], 1) : _vm._e()], 1)], 1) : _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md6": ""
      }
    }, [_c('v-form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.saveChangesSla.apply(null, arguments)
        }
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary--text subheader"
    }, [_vm._v("\n                    SLA\n                  ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_c('span', [_vm._v("Critical")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-text-field', {
      staticClass: "mt-0 pt-0",
      attrs: {
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSla.sla_critical),
        callback: function($$v) {
          _vm.$set(_vm.lCompSla, "sla_critical", $$v)
        },
        expression: "lCompSla.sla_critical"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                        Hours\n                      ")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_c('span', [_vm._v("Major")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-text-field', {
      staticClass: "mt-0 pt-0",
      attrs: {
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSla.sla_major),
        callback: function($$v) {
          _vm.$set(_vm.lCompSla, "sla_major", $$v)
        },
        expression: "lCompSla.sla_major"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                        Hours\n                      ")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_c('span', [_vm._v("Normal")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-text-field', {
      staticClass: "mt-0 pt-0",
      attrs: {
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSla.sla_normal),
        callback: function($$v) {
          _vm.$set(_vm.lCompSla, "sla_normal", $$v)
        },
        expression: "lCompSla.sla_normal"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                        Hours\n                      ")])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      staticClass: "pt-0"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "type": "submit",
        "color": "accent"
      }
    }, [_vm._v("save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md6": ""
      }
    }, [_c('span', {
      staticClass: "primary--text subheader"
    }, [_vm._v("SLA Escalation")]), _vm._v(" "), _c('v-form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.saveChangesSlaEsc.apply(null, arguments)
        }
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "title pb-0"
    }, [_vm._v("\n                    Level 1\n                  ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Email list (comma seperated)",
        "hide-details": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l1_email_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l1_email_list", $$v)
        },
        expression: "lCompSlaEsc.l1_email_list"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-3 pb-0",
      attrs: {
        "xs7": "",
        "sm5": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "label": "Notify via SMS",
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSlaEsc.l1_sms_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l1_sms_enabled", $$v)
        },
        expression: "lCompSlaEsc.l1_sms_enabled"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": !_vm.lCompSlaEsc.l1_sms_enabled,
        "label": "Phone number list",
        "hint": "Eg:- 9741012345,0014266471234",
        "persistent-hint": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l1_phone_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l1_phone_list", $$v)
        },
        expression: "lCompSlaEsc.l1_phone_list"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', {
      staticClass: "title pb-0 mt-2"
    }, [_vm._v("\n                Level 2\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Email list (comma seperated)",
        "hide-details": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l2_email_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l2_email_list", $$v)
        },
        expression: "lCompSlaEsc.l2_email_list"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-3 pb-0",
      attrs: {
        "xs7": "",
        "sm5": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "label": "Notify via SMS",
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSlaEsc.l2_sms_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l2_sms_enabled", $$v)
        },
        expression: "lCompSlaEsc.l2_sms_enabled"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": !_vm.lCompSlaEsc.l2_sms_enabled,
        "label": "Phone number list",
        "hint": "Eg:- 9741012345,0014266471234",
        "persistent-hint": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l2_phone_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l2_phone_list", $$v)
        },
        expression: "lCompSlaEsc.l2_phone_list"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      staticClass: "pt-0"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "type": "submit",
        "color": "accent"
      }
    }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " category\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Category",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lCompCat.comp_cat),
      callback: function($$v) {
        _vm.$set(_vm.lCompCat, "comp_cat", $$v)
      },
      expression: "lCompCat.comp_cat"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteCat(_vm.lCompCat)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37412121","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Compset.vue
// module id = 759
// module chunks = 31